// Generic legal content for Fundamental Signals

export const TERMS_OF_SERVICE_CONTENT = `
Terms of Use

Last updated: March 2025

1. Acceptance of Terms
By accessing or using Fundamental Signals ("Service"), you agree to be bound by these Terms of Use. If you do not agree to these terms, do not use the Service.

2. Description of Service
Fundamental Signals provides financial data, fundamental analysis tools, and investment research. The Service is for informational and educational purposes only and does not constitute investment, legal, or tax advice.

3. Eligibility
You must be at least 18 years of age and have the legal capacity to enter into binding contracts to use the Service. By using the Service, you represent that you meet these requirements.

4. Account and Password
You are responsible for maintaining the confidentiality of your account credentials. You agree to accept responsibility for all activities that occur under your account. Notify us immediately of any unauthorized use.

5. Acceptable Use
You agree not to: (a) use the Service for any illegal purpose; (b) attempt to gain unauthorized access to any part of the Service or related systems; (c) scrape, copy, or redistribute data in bulk without permission; (d) use the Service in any way that could harm, disable, or overburden the Service; (e) resell or sublicense access to the Service without authorization.

6. Subscription and Payment
Paid subscriptions are billed in advance (monthly or annually). Fees are non-refundable except as required by law or as stated in our refund policy. We reserve the right to change pricing with reasonable notice. Continued use after a price change constitutes acceptance.

7. Intellectual Property
All content, data, software, and materials provided through the Service are owned by Fundamental Signals or its licensors. You may not copy, modify, distribute, or create derivative works without express written permission.

8. Disclaimers
THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE." WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED. WE DO NOT GUARANTEE THE ACCURACY, COMPLETENESS, OR TIMELINESS OF DATA. PAST PERFORMANCE DOES NOT GUARANTEE FUTURE RESULTS. INVESTING INVOLVES RISK.

9. Limitation of Liability
TO THE MAXIMUM EXTENT PERMITTED BY LAW, FUNDAMENTAL SIGNALS AND ITS AFFILIATES SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS, DATA, OR GOODWILL, ARISING FROM YOUR USE OF THE SERVICE.

10. Indemnification
You agree to indemnify and hold harmless Fundamental Signals, its officers, directors, and employees from any claims, damages, or expenses arising from your use of the Service or violation of these terms.

11. Termination
We may suspend or terminate your access at any time for any reason. You may cancel your subscription at any time. Upon termination, your right to use the Service ceases immediately.

12. Changes to Terms
We may update these Terms from time to time. We will notify you of material changes by posting the updated Terms on the Service or by email. Your continued use after such notice constitutes acceptance of the new Terms.

13. Governing Law and Disputes
These Terms are governed by the laws of the United States. Any disputes shall be resolved through binding arbitration or in the courts of competent jurisdiction.

14. Contact
For questions about these Terms, contact us at fundamentalsignals@gmail.com.
`;

export const PRIVACY_POLICY_CONTENT = `
Privacy Policy

Last updated: March 2025

1. Introduction
Fundamental Signals ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website and services.

2. Information We Collect
We may collect:
• Account information: email, password (hashed), and account preferences.
• Usage data: how you use our site, pages visited, features used, and device information (browser, IP address, device type).
• Financial or investment data: only to the extent you voluntarily provide it (e.g., watchlists, portfolio data) to personalize your experience.
• Cookies and similar technologies: to remember preferences and improve site performance.

3. How We Use Your Information
We use collected information to:
• Provide, maintain, and improve our services.
• Process subscriptions and communicate about your account.
• Send service-related notices and, with your consent, marketing communications.
• Analyze usage to improve user experience and product offerings.
• Comply with legal obligations and protect our rights.

4. Data Sharing and Disclosure
We do not sell your personal information. We may share data with:
• Service providers (hosting, analytics, payment processors) who assist in operating our business under strict confidentiality.
• Legal and regulatory authorities when required by law or to protect our rights and safety.
• In connection with a merger, sale, or acquisition of our business (with notice to you).

5. Data Security
We implement industry-standard security measures including encryption (e.g., HTTPS, secure storage), access controls, and regular security assessments to protect your personal and financial data.

6. Data Retention
We retain your information for as long as your account is active or as needed to provide services, comply with law, resolve disputes, and enforce our agreements.

7. Your Rights
Depending on your location, you may have the right to:
• Access, correct, or delete your personal data.
• Object to or restrict certain processing.
• Data portability.
• Withdraw consent where processing is consent-based.
• Lodge a complaint with a supervisory authority.

To exercise these rights, contact us at fundamentalsignals@gmail.com.

8. Cookies and Tracking
We use cookies and similar technologies for authentication, preferences, and analytics. You can manage cookie preferences in your browser settings.

9. Children's Privacy
Our services are not directed to individuals under 18. We do not knowingly collect personal information from children.

10. International Transfers
Your data may be processed in the United States or other countries where our service providers operate. We ensure appropriate safeguards where required by law.

11. Changes to This Policy
We may update this Privacy Policy from time to time. We will post the updated policy on our website and indicate the effective date. Continued use after changes constitutes acceptance.

12. Contact Us
For privacy-related questions or requests, contact us at fundamentalsignals@gmail.com.
`;
